import { MenuItem } from '@cargomart/ui'
import { useNavigate } from '@tanstack/react-router'
import cn from 'classnames'
import { useIsTablet } from 'hooks'
import { useActions } from 'hooks/useActions'
import { useLogoutMutation } from 'modules/login/api'
import { profileInfoRoute } from 'modules/profile/routes'
import { cleanAuthData } from 'store/auth/auth'

import s from './MenuDropdown.module.less'

type MenuDropdownProps = {
  onClose?: () => void
}

export const MenuDropdown = ({ onClose }: MenuDropdownProps) => {
  const isTablet = useIsTablet()
  const [logout, { isLoading }] = useLogoutMutation()
  const { closeMobileSidebar } = useActions()
  const navigate = useNavigate()
  const handleClose = () => {
    onClose?.()
    closeMobileSidebar()
  }

  const handleLogout = async () => {
    if (isLoading) return
    await logout('')
    cleanAuthData()
    navigate({ to: '/', replace: true })
  }
  const handleNavigateToSettings = () => {
    navigate({ to: profileInfoRoute.to, replace: true })
    handleClose()
  }

  return (
    <div className={cn(s.menu, 'p-1')}>
      {!isTablet && (
        <>
          <MenuItem className="!py-1.5 px-3" onClick={handleNavigateToSettings} title="Учетная запись" />
          <hr className={cn(s.line)} />
        </>
      )}

      <MenuItem className="!py-1.5 px-3 max-md:!py-2 max-md:px-3" onClick={handleLogout} title="Выйти" />
    </div>
  )
}
